<div class="h-full flex flex-col">
  <!-- <div class="ml-2">
    <uni-breadcrumb></uni-breadcrumb>
  </div> -->
  <div class="flex grow min-h-0 gap-2 mt-3">
    <!-- COLLAPSIBLE SIDEBAR WRAPPER -->
    <div *ngIf="items.length" class="sidebar-wrapper" [class.collapsed]="isSidebarCollapsed">
      <!-- TOGGLE BUTTON WITH ARROW ICON -->
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <!-- SIDEBAR CONTAINER WITH MENU AND BUTTONS -->
      <div class="sidebar-container">
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="true"></p-panelMenu>

        <!-- Context-sensitive button for Purchase Orders page -->
        <button
          *ngIf="showCreateNewPoButton"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-plus"
          (click)="createNewPo()"
        >
          <span>Create New Stock P/O</span>
        </button>

        <!-- Context-sensitive buttons for Backorders page -->
        <ng-container *ngIf="showBackorderButtons">
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-4"
            icon="pi pi-envelope"
            [disabled]="backorderButtonsDisabled || backorderFormDirty"
            (click)="sendAccountEmail()"
          >
            <span>Send Account Email</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-2"
            icon="pi pi-envelope"
            [disabled]="backorderButtonsDisabled || backorderFormDirty"
            (click)="sendManufEmail()"
          >
            <span>Send Manufacturer Email</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-4"
            icon="pi pi-eye"
            [disabled]="backorderFormDirty"
            (click)="showHideIdColumns()"
          >
            <span>Show/Hide Id Columns</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-4"
            icon="pi pi-key"
            [disabled]="backorderButtonsDisabled || backorderFormDirty"
            (click)="resetAccountGuid()"
          >
            <span>Reset Account CrytoKey</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-2"
            icon="pi pi-key"
            [disabled]="backorderButtonsDisabled || backorderFormDirty"
            (click)="resetManufGuid()"
          >
            <span>Reset Manufacturer CrytoKey</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-4"
            icon="pi pi-building"
            [disabled]="backorderButtonsDisabled || backorderFormDirty"
            (click)="gotoAccountPage()"
          >
            <span>Go to Account Page</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-raised p-button-sm mt-2"
            icon="pi pi-truck"
            [disabled]="backorderButtonsDisabled || backorderFormDirty"
            (click)="gotoManufPage()"
          >
            <span>Go to Manufacturer Page</span>
          </button>
        </ng-container>
      </div>
    </div>
    <!-- MAIN CONTENT AREA -->
    <div class="grow flex flex-col min-h-0 ml-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
